import React, { useEffect, useRef } from 'react';
import OpenedSvg from '../images/opened';
import ClosedSvg from '../images/closed';
import config from '../../../config';
import Link from '../link';

const TreeNode = ({ className = '', setCollapsed, collapsed, url, title, items, ...rest }) => {
  const isCollapsed = collapsed[url];

  const nodeRef = useRef(null);

  const collapse = () => {
    setCollapsed(url);
  };

  const hasChildren = items && items.length !== 0;

  let location;

  if (typeof document !== 'undefined') {
    location = document.location;
  }
  const active =
    location && (location.pathname === url || location.pathname === config.gatsby.pathPrefix + url);

  const calculatedClassName = `${className} item ${active ? 'active' : ''}`;

  // Use useEffect to scroll to the active element
  useEffect(() => {
    if (active && nodeRef.current) {
      // Optional: set focus for accessibility
      nodeRef.current.focus && nodeRef.current.focus();
      // Use requestAnimationFrame to ensure layout is ready
      requestAnimationFrame(() => {
        nodeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }, [active]);


  return (
    <li className={calculatedClassName} ref={nodeRef}>
      {title && (
        <Link to={url}>
          {title}
          {!config.sidebar.frontLine && title && hasChildren ? (
            <button onClick={collapse} aria-label="collapse" className="collapser" style={{ marginRight: '10px' }}>
              {!isCollapsed ? <OpenedSvg /> : <ClosedSvg />}
            </button>
          ) : null}
        </Link>
      )}

      {!isCollapsed && hasChildren ? (
        <ul>
          {items.map((item, index) => (
            <TreeNode
              key={item.url + index.toString()}
              setCollapsed={setCollapsed}
              collapsed={collapsed}
              {...item}
            />
          ))}
        </ul>
      ) : null}
    </li>
  );
};

export default TreeNode;
